import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  IMAGE_PADDING_TYPE,
  FONT_FAMILIES,
  FONT_SIZES,
  HORIZONTAL_POSITION,
  FONT_FAMILY_ROBOTO,
  TEXT_PROPS_VALIDATION,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'video_src',
    label: 'Video Source',
    type: types.TEXT,
    options: {
      validation: TEXT_PROPS_VALIDATION.VIDEO_PLAYER,
    }
  },
  {
    key: 'cover_image',
    label: 'Cover Image',
    type: types.TEXT
  },
  {
    key: 'caption',
    label: 'Caption',
    type: types.TEXT
  },
  {
    key: 'internal_video_props',
    label: 'Internal Video Properties',
    type: types.OBJECT,
    children: [
      {
        type: types.BOOLEAN,
        key: 'autoplay',
        label: 'Autoplay (autoplay mutes the videos automatically)',
      },
      {
        type: types.BOOLEAN,
        key: 'loop',
        label: 'Loop',
      },
      {
        type: types.BOOLEAN,
        key: 'muted',
        label: 'Muted',
      },
      {
        type: types.BOOLEAN,
        key: 'controls',
        label: 'Controls',
      },
      {
        type: types.BOOLEAN,
        key: 'downloadable',
        label: 'Download (requires controls to be enabled)',
      }
    ]
  },
  {
    key: 'youtube_link',
    label: 'YouTube Link',
    type: types.TEXT
  },
  {
    key: 'title_props',
    label: 'Title Properties',
    type: types.OBJECT,
    children: [
      {
        key: 'color_theme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXTAREA
      },
      {
        key: 'title_font',
        label: 'Title Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'title_font_size',
        label: 'Title Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
      {
        key: 'title_font_weight',
        label: 'Title Font Weight',
        type: types.TEXT
      },
      {
        key: 'title_opacity',
        label: 'Title Opacity',
        type: types.TEXT
      },
      {
        key: 'title_line_height',
        label: 'Title Line Height (px)',
        type: types.TEXT
      },
      {
        key: 'content_padding_top',
        label: 'Content Top Padding',
        type: types.TEXT
      },
      {
        key: 'title_padding_left_right',
        label: 'Title Left/Right Padding',
        type: types.TEXT
      },
      {
        key: 'title_position',
        label: 'Title Position',
        type: types.ENUM,
        options: HORIZONTAL_POSITION
      },
    ]
  },
  {
    type: types.OBJECT,
    key: 'social_share',
    label: 'Social Share',
    children: [
      {
        type: types.BOOLEAN,
        key: 'show_social_icons',
        label: 'Show Social Icons'
      },
      {
        type: types.ENUM,
        key: 'color_theme',
        label: 'Color Theme',
        options: COMPONENT_COLOR_THEMES
      },
      {
        type: types.TEXT,
        key: 'qr_code_url',
        label: 'QR Code URL'
      },
      {
        type: types.ARRAY,
        key: 'social_media_icons',
        label: 'Social Media Icons',
        children: [
          {
            type: types.TEXT,
            key: 'url',
            label: 'URL',
          },
          {
            type: types.TEXT,
            key: 'icon',
            label: 'Icon'
          }
        ]
      }
    ]
  },
  {
    key: 'padding_type',
    label: 'Padding Type',
    type: types.ENUM,
    options: IMAGE_PADDING_TYPE
  },
  {
    key: 'custom_image_padding',
    label: 'Custom Image Padding (px)',
    type: types.TEXT
  },
  {
    key: 'intersection_observer_threshold',
    label: 'Intersection Observer Threshold (Range: 0 ~ 1.0 Default: 0)',
    type: types.TEXT
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  }
];

const defaultProps = {
  video_src: '',
  youtube_link: 'https://www.youtube.com/watch?v=Mziv4PzUxQo',
  cover_image: '',
  caption: '',
  internal_video_props: {
    autoplay: false,
    loop: false,
    muted: false,
    controls: true,
    downloadable: true,
  },
  title_props: {
    color_theme: 'DARK',
    title: '',
    title_font: FONT_FAMILY_ROBOTO,
    title_font_size: '60px',
    title_font_weight: '400',
    title_opacity: '1',
    title_line_height: 'normal',
    content_padding_top: '30%',
    title_padding_left_right: '0px',
    title_position: 'center',
  },
  social_share: {
    show_social_icons: false,
    color_theme: 'DARK',
    qr_code_url: 'https://www.ff.com/',
    social_media_icons: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  },
  padding_type: 'Non-FutureSight Padding',
  custom_image_padding: '0px',
  color_theme: 'LIGHT'
};

export default {
  title: 'Video Player',
  id: 'VideoPlayer',
  widgetImage: '/widgetImages/Video.png',
  basic: true,
  propsSchema,
  defaultProps
};
